export default "__VITE_ASSET__emdIYsyD__"